// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.virtual-tour iframe {
  width: 100%;
  border: 0;
  height: 600px;
  max-height: 100vh;
  margin: 20px 0;
}

@media print {
  .virtual-tour {
    display: none;
  }
}
.has-promo {
  text-decoration: line-through;
}

.whitespace-pre-wrap {
  white-space: pre-wrap;
}

@media print {
  .facilities {
    flex-direction: row !important;
  }
}

.custom-container {
  padding-top: 15px;
  padding-bottom: 15px;
}

.slider {
  padding-bottom: 0;
}

.like {
  padding-top: 10px;
  text-align: center;
  display: block;
}
.like mat-icon {
  cursor: pointer;
  width: 60px;
  height: 60px;
  font-size: 60px;
}
.like mat-icon.selected {
  --tw-text-opacity: 1;
  color: rgb(26 39 65 / var(--tw-text-opacity));
}

aside {
  width: 100%;
}
@media only screen and (min-width: 960px) {
  aside .contact-agent {
    position: fixed;
  }
}

.contact-agent {
  padding: 20px;
  background-color: #fff;
  margin-bottom: 0 !important;
}
.contact-agent h2 {
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 18px;
}
.contact-agent div a,
.contact-agent div div {
  margin: 2.5px 0;
  width: 100%;
  overflow: hidden;
}
.contact-agent img {
  max-height: 26px;
  max-width: 26px;
  margin-right: 15px;
}

.property-status {
  --tw-bg-opacity: 1;
  background-color: rgb(26 39 65 / var(--tw-bg-opacity));
  font-weight: bold;
  font-size: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  color: #fff;
  padding: 5px 10px;
  border-radius: 4px;
}

.house-details {
  width: 100%;
}

@media only screen and (min-width: 960px) {
  .container {
    width: calc(100vw - 40px);
  }
  .container aside,
  .container .contact-agent {
    width: 300px;
  }
  .container .house-details {
    width: calc(100vw - 340px);
  }
}
@media only screen and (min-width: 1440px) {
  .container {
    width: 100%;
    max-width: 1250px;
  }
}

.description {
  text-align: justify;
  white-space: pre-wrap;
  margin-bottom: 20px;
  line-height: 1.5;
}

.title-container {
  margin-top: 0;
}
@media screen {
  .title-container {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
.title-container label {
  min-height: 40px;
  padding-top: 6px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
}
@media only screen and (min-width: 960px) {
  .title-container label {
    text-align: right;
  }
}
.title-container label .vat {
  font-size: 12px;
}
.title-container h2 {
  display: inline-block;
  text-align: left;
  margin-top: 0;
  margin-bottom: 0;
}

.house-description {
  padding-top: 0;
}
.house-description h5 {
  margin-bottom: 7.5px;
  font-size: 16px;
}
.house-description ul {
  list-style-type: circle;
  padding-left: 20px;
}
@media only screen and (min-width: 960px) {
  .house-description {
    text-align: left;
  }
}
.house-description .zone-and-city {
  margin-bottom: 10px;
  text-align: center;
}
@media only screen and (min-width: 600px) {
  .house-description .zone-and-city {
    text-align: left;
  }
}
.house-description .status-container {
  margin-bottom: 15px;
}
.house-description .status-container label {
  display: inline-block;
  padding: 2.5px 7.5px;
  background-color: #2d2d2d;
  color: #fff;
  text-transform: uppercase;
  z-index: 1;
}
@media only screen and (min-width: 600px) {
  .house-description .status-container {
    margin-top: 15px;
  }
}
.house-description p {
  width: 100%;
}
.house-description .bullet-list {
  margin-top: 10px;
}
.house-description .bullet-list li {
  width: 100%;
  margin-right: 0;
  text-align: left;
}
@media only screen and (min-width: 600px) {
  .house-description .bullet-list li {
    width: 50%;
    padding-right: 15px;
  }
}
@media only screen and (min-width: 1280px) {
  .house-description .bullet-list li {
    width: 33.3333%;
  }
}
.house-description .bullet-list li::before {
  font-size: 20px;
}

table {
  text-align: left;
}
table td:first-child {
  font-weight: normal;
  position: relative;
  padding-left: 12.5px;
  padding-right: 10px;
}
table td:first-child::before {
  --tw-bg-opacity: 1;
  background-color: rgb(26 39 65 / var(--tw-bg-opacity));
  transform: translateY(-50%);
  content: "";
  display: inline-block;
  height: 7px;
  width: 7px;
  position: absolute;
  left: 0;
  top: 13px;
  border-radius: 50%;
}
@media screen {
  table tr {
    height: 24px;
  }
}

.price-type-copy {
  padding: 10px 0;
}
.price-type-copy:before {
  display: none !important;
}

.description-list {
  margin-top: 15px;
  margin-bottom: 15px;
}
@media only screen and (min-width: 960px) {
  .description-list {
    margin-top: 7.5px;
  }
}
.description-list table:first-child {
  margin-right: 15px;
}
@media only screen and (min-width: 600px) {
  .description-list table:first-child {
    margin-right: 30px;
  }
}
.description-list table:last-child {
  margin-bottom: 15px;
}
@media only screen and (min-width: 960px) {
  .description-list table:last-child {
    margin-bottom: 0;
  }
}

.files {
  width: 100%;
  margin-bottom: 20px;
}
.files a {
  --tw-border-opacity: 1;
  border-color: rgb(26 39 65 / var(--tw-border-opacity));
  width: 100%;
  max-width: 100%;
  border-bottom: 1px solid;
  min-height: 36px;
  position: relative;
  padding-left: 12.5px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.files a::before {
  --tw-bg-opacity: 1;
  background-color: rgb(26 39 65 / var(--tw-bg-opacity));
  transform: translateY(-50%);
  content: "";
  display: inline-block;
  height: 7px;
  width: 7px;
  position: absolute;
  left: 0;
  top: 50%;
  border-radius: 50%;
}
.files a:hover {
  background-color: #f2f2f2;
}
.files a label {
  padding-left: 12.5px;
  padding-right: 12.5px;
  min-width: 100px;
  text-align: center;
  cursor: pointer;
}
.files a span {
  max-width: calc(100% - 100px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

app-open-street-map ::ng-deep .osm {
  height: 500px;
}

app-images-carousel-base ::ng-deep section.carousel-container div.carousel-slides-container {
  height: 400px !important;
}
@media only screen and (min-width: 600px) {
  app-images-carousel-base ::ng-deep section.carousel-container div.carousel-slides-container {
    height: 700px !important;
  }
}

.embedHtml::ng-deep > * {
  margin: 20px 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
